import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Box, Button, Typography } from '@mui/material'
import { ArrowLeftIcon, ErrorServerIcon } from '~/assets/icons'
import { marginX } from '~/constants'
import { useNavigate } from 'react-router-dom'
import { useThemeContext } from '~/theme/ThemeProvider'

// Dùng trong trường hợp server trả về lỗi
const ErrorServer = ({ onRetry, isGoBackBtn, paddingTop = '20%' }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { currentThemeObject } = useThemeContext()

  const renderBackBtn = () => {
    if (!isGoBackBtn) return null

    return (
      <Box onClick={() => navigate(-1)} display="inline-block" marginLeft="20px">
        <ArrowLeftIcon color={currentThemeObject.colorText1} />
      </Box>
    )
  }

  return (
    <Box paddingTop={paddingTop} minHeight="100vh">
      {renderBackBtn()}
      <Box>
        <ErrorServerIcon width="100%" />
        <Typography
          textAlign="center"
          paddingTop="4px"
          fontSize="2.4rem"
          fontWeight="500"
          lineHeight="2.8rem"
          color="baseColor.colorText1">
          {t('errors.server_error')}
        </Typography>
      </Box>

      <Box marginX={`${marginX}px`} marginTop="20px" paddingY="10px" paddingBottom="50px">
        {onRetry && typeof onRetry === 'function' ? (
          <Button
            sx={{ paddingY: '12px', fontSize: '1.8rem' }}
            fullWidth
            variant="primary"
            onClick={onRetry}
            marginBottom="20px">
            {t('actions.retry')}
          </Button>
        ) : null}
      </Box>
    </Box>
  )
}

export default React.memo(ErrorServer)
ErrorServer.propTypes = {
  loading: PropTypes.bool,
  onRetry: PropTypes.func,
  isGoBackBtn: PropTypes.bool,
  paddingTop: PropTypes.string,
}
